import React, { useContext } from "react";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { IconButton, Tooltip } from '@mui/material';

import { Context } from "../Provider";
import DivSpinner from "../../../components/divSpinner";
import ColumnSort from "./ColumnSort";
import { theme } from "../../../theme";
import { downloadInvoice } from "../service";

const Table = () => {
    const context = useContext(Context);

    return(
        <>
            {context.state.is_loading ? (
                <div style={{height : `${window.innerHeight-387}px`}}>
                    <DivSpinner/>
                </div>
            ) : (
                <div className="table-responsive p-0">
                    <table className="table align-items-center mb-0">
                        <thead>
                            <tr>
                                {[
                                    'Job ID',
                                    'Tradesperson', 
                                    <span>Materials<br/>Charge</span>,
                                    <span>Company<br/>commission<br/>(Materials)</span>,
                                    'Discount',
                                    <span>Tradesperson<br/>Charge</span>,
                                    <span>Company<br/>Commission</span>,
                                    'Total',
                                    'status',
                                    ''
                                ].map((text, index) => (
                                    <th 
                                        key={index}
                                        className={`text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ${text === 'Count' ? 'text-center' : ''}`}
                                    >
                                        <ColumnSort sortKeyName={text} />
                                    </th>
                                ))}
                                <th className="text-secondary opacity-7"></th>
                            </tr>
                        </thead>
                        <tbody>
                        {context.state.job_invoices.length > 0 ? (
                            <>
                                {context.state.job_invoices.map((invoice, index) => (
                                    <tr key={index}>
                                        <td className="align-middle">
                                            <span className="text-secondary text-sm font-weight-bold">{invoice.job_invoice_job_id}</span>
                                        </td>
                                        <td className="align-middle">
                                            <span className="text-secondary text-sm font-weight-bold">{invoice.ftm.ftm_forename} {invoice.ftm.ftm_surname}</span>
                                        </td>
                                        <td className="align-middle">
                                            <span className="text-secondary text-sm font-weight-bold">{theme.currency} {invoice.total_materials_cost}</span>
                                        </td>
                                        <td className="align-middle">
                                            <span className="text-secondary text-sm font-weight-bold">{theme.currency} {invoice.materials_company_commission}</span>
                                        </td>
                                        <td className="align-middle">
                                            <span className="text-secondary text-sm font-weight-bold">{theme.currency} {invoice.job_discount}</span>
                                        </td>
                                        <td className="align-middle">
                                            <span className="text-secondary text-sm font-weight-bold">{theme.currency} {invoice.ftm_payment}</span>
                                        </td>
                                        <td className="align-middle">
                                            <span className="text-secondary text-sm font-weight-bold">{theme.currency} {invoice.tradesperson_fee_company_commission}</span>
                                        </td>
                                        <td className="align-middle">
                                            <span className="text-secondary text-sm font-weight-bold">{theme.currency} {invoice.job_value}</span>
                                        </td>
                                        <td className="align-middle text-sm">
                                            <span className={`badge badge-sm bg-gradient-${invoice.job_is_pay_ftm === 1 ? 'success' : 'danger'}`}>
                                                {invoice.job_is_pay_ftm === 1 ? 'Paid' : 'Not Paid'}
                                            </span>
                                        </td>
                                        <td className="align-middle">
                                            <Tooltip title="Download Invoice">
                                                <IconButton
                                                    aria-label="download"
                                                    onClick={() => downloadInvoice(invoice.job_invoice_job_id)}
                                                >
                                                    <FileDownloadIcon/>
                                                </IconButton>
                                            </Tooltip>
                                        </td> 
                                    </tr>
                                ))}
                            </>
                        ) : (
                            <tr>
                                <td className="text-center" colSpan="10">Sorry, no data found!</td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
            )}
        </>
    );
}

export default Table;